module.exports = __webpack_public_path__ + "img/mind_skeleton_time_12.6be5b7ca.png";